export const CHECKOUT_DRAFT_STORAGE_KEY = 'rostech_saas_checkout_draft';

export type CheckoutDraftSnapshot = {
  step: 1 | 2;
  planId: string;
  period: string;
  companyName: string;
  name: string;
  email: string;
  phone: string;
  documentId: string;
};

export function saveCheckoutDraft(snapshot: CheckoutDraftSnapshot): void {
  try {
    sessionStorage.setItem(CHECKOUT_DRAFT_STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    /* quota / modo privado */
  }
}

export function loadCheckoutDraft(): CheckoutDraftSnapshot | null {
  try {
    const raw = sessionStorage.getItem(CHECKOUT_DRAFT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CheckoutDraftSnapshot;
    if (!parsed?.planId || !parsed?.period || (parsed.step !== 1 && parsed.step !== 2)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearCheckoutDraft(): void {
  try {
    sessionStorage.removeItem(CHECKOUT_DRAFT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
